import * as Sentry from '@sentry/react';

type ErrorDetails = Record<string, unknown>;

function getPath(): string | undefined {
  return typeof window !== 'undefined'
    ? window.location.pathname
    : undefined;
}

export function toError(value: unknown): Error {
  if (value instanceof Error) {
    return value;
  }

  if (
    typeof value === 'object' &&
    value !== null &&
    'message' in value &&
    typeof (value as { message: unknown }).message === 'string'
  ) {
    const obj = value as { message: string; code?: string };
    const prefix = obj.code ? `[${obj.code}] ` : '';
    const error = new Error(`${prefix}${obj.message}`);
    (error as Error & { originalError: unknown }).originalError = value;
    return error;
  }

  return new Error(String(value));
}

export function captureError(
  error: unknown,
  context?: string,
  details?: ErrorDetails,
): void {
  const normalizedError = toError(error);
  Sentry.captureException(normalizedError, {
    extra: { context, path: getPath(), ...details },
  });
}

export function captureQueryError(error: unknown, context: string): void {
  const normalizedError = toError(error);
  Sentry.captureException(normalizedError, {
    tags: { errorType: 'query-ui' },
    extra: { context, path: getPath() },
  });
}
